// Shared v2.0 form-control class string for Input / Textarea / Select.
// Mirrors the static `.input/.select/.textarea` (brand/components.css): white surface,
// line border, electric focus ring, 44px tap target, and **≥16px font** to block
// iOS Safari's zoom-on-focus. `error` swaps the border to the danger token.
export function fieldControl(error?: unknown): string {
  return [
    'w-full min-h-control px-4 py-2.5 border rounded-control text-base text-ink-body',
    'placeholder:text-ink-muted transition-colors duration-fast ease-out-soft',
    'focus-visible:outline-none focus:border-vjal-400 focus-visible:shadow-focus',
    'disabled:bg-whisper disabled:text-ink-muted disabled:cursor-not-allowed',
    // hover border + error surface tint mirror the static `.input` (components.css)
    error ? 'bg-err-bg border-err' : 'bg-white border-line hover:border-ink-soft',
  ].join(' ')
}
